import UtivaLogo from "../../../assets/images/svg/build/utiva-logo.svg";

const BuildBrand = ({ ariaLabel }) => {
  return (
    <a className="apl-brand" href="#top" aria-label={ariaLabel}>
      <img src={UtivaLogo} alt="Utiva" />
      <span className="apl-brand-label">AI Product Lab</span>
    </a>
  );
};

export default BuildBrand;
